import React, { Fragment, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import './App.css';
import { ThemeProvider } from '@material-ui/core/styles';

import PrivateRoute from './components/routing/PrivateRoute';
import setAuthToken from './utils/setAuthToken';
import store from './store';
import { loadUser } from './actions/auth';

import Navbar from './components/Layout/Navbar';
import Register from './components/auth/Register';
import Landing from './components/Layout/Landing';
import AddContact from './components/contact/AddContact';
import ActionStreams from './components/actionStream/ActionStreams';
import ViewContact from './components/contact/ViewContact';
import EditContact from './components/contact/EditContact';
import AllContacts from './components/contact/AllContacts';
import AllDeals from './components/deal/AllDeals';
import AllActivities from './components/activity/AllActivities';
import theme from './components/materialFunctions/Theme';

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);
  return (
    <Provider store={store}>
      <Router>
        <Fragment>
          <ThemeProvider theme={theme}>
            <Navbar />
            <section>
              <Switch>
                <Route exact path='/' component={Landing} />
                <Route exact path='/register' component={Register} />
                <PrivateRoute exact path='/actions' component={ActionStreams} />
                <PrivateRoute exact path='/addcontact' component={AddContact} />
                <PrivateRoute exact path='/contacts' component={AllContacts} />
                <PrivateRoute exact path='/deals' component={AllDeals} />
                <PrivateRoute
                  exact
                  path='/activities'
                  component={AllActivities}
                />
                <PrivateRoute
                  exact
                  path='/show_contact/:id'
                  component={ViewContact}
                />
                <PrivateRoute
                  exact
                  path='/edit_contact/:id'
                  component={EditContact}
                />
              </Switch>
            </section>
          </ThemeProvider>
        </Fragment>
      </Router>
    </Provider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js